import { useEffect } from 'react'

import cloudinaryUrl from 'src/utils/cloudinaryUrl'

const sizes = [
  { size: 120, border: '12px' },
  { size: 180, border: '18px' },
]

const useAppleTouchIcons = source => {
  useEffect(() => {
    if (!source) return

    const originalIcon = document.querySelector(
      'link[rel="apple-touch-icon"][href="/apple-touch-icon.png"]'
    )

    const clearIcons = () =>
      document.head.querySelectorAll('link[rel="apple-touch-icon"]')
      .forEach(link => {
        if (link != originalIcon)
          document.head.removeChild(link)
      })
    clearIcons()

    sizes.forEach(({ size, border }) => {
      const path = cloudinaryUrl(source, {
        width: size,
        height: size,
        crop: 'pad',
        fetchFormat: 'png',
        background: 'white',
        border: `${border}_solid_white`,
      })
      const link = document.createElement('link')
      link.setAttribute('rel', 'apple-touch-icon')
      link.setAttribute('href', path)
      link.setAttribute('sizes', `${size}x${size}`)
      document.head.insertBefore(link, originalIcon)
    })

    return clearIcons
  }, [ source ])
}

export default useAppleTouchIcons
